export class Generic {
    op?: number;
    option?: number;
}